import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import { Background } from '../COMPONENTS/Background';
import Dot from '../COMPONENTS/Dot';
import { windowSize, scrollClass } from '../../HOME/utils';
import { EMAIL, YOUTUBE } from '../../HOME/const';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';
import { YOUTUBE_TA } from '../const';

const SEE_THE_FORMULA = 'See the formula.';

class HelpPage extends Component {
  state = {};

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleSeeFormula = run => {
    if (run === SEE_THE_FORMULA) {
      this.setState({ showFormula: true });
    }
  };

  handleClick = e => {
    if (e.target.id !== SEE_THE_FORMULA) {
      this.setState({ showFormula: false });
    }
  };

  render() {
    return (
      <div className="page-root triangula-page" style={{ backgroundImage: Background, alignContent: 'center' }} onClick={this.handleClick}>
        <div className={scrollClass} style={{ gridArea: '1/1', margin: '25px 0 55px' }}>
          <Item content="Players take turns connecting dots with lines. Every time a line closes a triangle, the player scores and moves again. The winner is the player whose triangles cover the largest area at the end of the game." />
          <Item content="To create a line, •tap on two dots• to connect them." />
          <Item content="A line cannot pass through other dots or cross other lines. •Only triangles formed by three direct connections count.•" />
          <Item content="It is possible to create a large triangle that covers one or more of the previously created smaller triangles, in which case •the smaller triangles are discounted." />
          <Item
            onSeeFormula={this.handleSeeFormula}
            content="Your grade is based on your average score, the balance of wins and loses, and the number of games played. •Play ten times or more• to get full credit. •See the formula.•"
          />
          <Item content="If the game is surrendered before completion, the AI is declared the winner, but your score still counts towards your grade." />
          <Item content="The AI does not cheat. If you think it did, please use the •playback feature• to see what actually happened." />
          <Item content="To make a player go first, tap on the player's icon at the start of the game." />
        </div>
        {this.state.showFormula && (
          <div className="message formula fadein-fast">
            <div>Grade = A × (2P ÷ 3G) × min(10,G)</div>
            <br />
            <div>A = average score (%)</div>
            <div>P = 2 × wins + 1½ × draws + losses</div>
            <div>G = number of games played</div>
            <div>min(10,G) = the lesser of 10 and G</div>
            <br />
            <div>
              For example, if you played 10 games or more, won as many games as you lost, and your average score is 50%, then your grade is 500.
            </div>
          </div>
        )}
        <div className="home-center-button-toolbar">
          <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_TA} />
        </div>
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  {}
)(HelpPage);

const Item = props => {
  const { x: wx } = windowSize();
  const grid = `auto / auto ${wx <= 590 ? wx - 57 : 550}px`;
  const fontSize = `${wx < 768 ? 15 : 16}px`;

  const text = props.content.toString();
  const runs = _.split(text, '•');

  return (
    <div className="help-item" style={{ grid, fontSize }}>
      <span style={{ margin: '6px 10px 0 0' }}>
        <Dot size="7" />
      </span>
      <div>
        {_.map(runs, (run, i) => {
          let color = i % 2 ? 'gold' : 'white';
          let cursor = 'initial';
          let id = '';
          let select = 'none';

          if (run === SEE_THE_FORMULA) {
            id = run;
            color = 'aquamarine';
            cursor = 'pointer';
          } else if (run === EMAIL) {
            select = 'all';
          }

          return (
            <span
              key={i}
              id={id}
              style={{ color, cursor, userSelect: select }}
              onClick={() => {
                if (props.onSeeFormula) {
                  props.onSeeFormula(run);
                }
              }}>
              {run === EMAIL ? (
                <a href={`mailto:${EMAIL}`} style={{ color: 'aquamarine', textDecoration: 'none', userSelect: 'all' }}>
                  {EMAIL}
                </a>
              ) : (
                run
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
};
